// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPrefundReplenishmentPercentPropertyDto
 */
export interface IPrefundReplenishmentPercentPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IPrefundReplenishmentPercentPropertyDto
     */
    prefund_replenishment_percent?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundReplenishmentPercentPropertyDto
     */
    prefund_replenishment_percent_state?: IPrefundReplenishmentPercentPropertyDtoPrefundReplenishmentPercentStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPrefundReplenishmentPercentPropertyDtoPrefundReplenishmentPercentStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IPrefundReplenishmentPercentPropertyDto interface.
 */
export function instanceOfIPrefundReplenishmentPercentPropertyDto(value: object): value is IPrefundReplenishmentPercentPropertyDto {
    return true;
}

export function IPrefundReplenishmentPercentPropertyDtoFromJSON(json: any): IPrefundReplenishmentPercentPropertyDto {
    return IPrefundReplenishmentPercentPropertyDtoFromJSONTyped(json, false);
}

export function IPrefundReplenishmentPercentPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPrefundReplenishmentPercentPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'prefund_replenishment_percent': json['prefund_replenishment_percent'] == null ? undefined : json['prefund_replenishment_percent'],
        'prefund_replenishment_percent_state': json['prefund_replenishment_percent_state'] == null ? undefined : json['prefund_replenishment_percent_state'],
    };
}

export function IPrefundReplenishmentPercentPropertyDtoToJSON(json: any): IPrefundReplenishmentPercentPropertyDto {
    return IPrefundReplenishmentPercentPropertyDtoToJSONTyped(json, false);
}

export function IPrefundReplenishmentPercentPropertyDtoToJSONTyped(value?: IPrefundReplenishmentPercentPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prefund_replenishment_percent': value['prefund_replenishment_percent'],
        'prefund_replenishment_percent_state': value['prefund_replenishment_percent_state'],
    };
}

